'use strict'

import angular from 'angular'
import ShowController from './show.controller'

export default angular.module('onyxReadingRoomApp.deviceconfigs.show', [])
  .controller('DeviceConfigsShowController', ShowController)
  .name



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/show/index.js